import React from "react";
import { isRouteErrorResponse, useRouteError } from "react-router-dom";
import Login from "./login";
import ErrorPage from "./ErrorPage";


export default function ErrorBoundary() {
    const error = useRouteError();
    console.error(error?.message || "No route error message");

    if (isRouteErrorResponse(error) && error === 401) {
      return <Login />;
    }

    return <ErrorPage />;  
}
